import React from 'react';
import { AdminPageHeader } from '../../components/admin/shell';
import BookingFeesPanel from '../../components/admin/BookingFeesPanel';

export default function FeesPage() {
  return (
    <>
      <AdminPageHeader section="fees" meta="What the buyer pays and what the provider keeps." />
      <BookingFeesPanel />
    </>
  );
}
